<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center; margin-bottom: 20px;">
      <span>确定删除账户提现</span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="deleteAccountWithdrawalApply">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAccountWithdrawalApply } from '@/api/goods/accountWithdrawalApplyApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteAccountWithdrawalApply',
  data() {
    return {
      dialogVisible: false,
      deleteAccountWithdrawalApplyInfo: {
        applyId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(data) {
      this.deleteAccountWithdrawalApplyInfo = { ...data }
      this.deleteAccountWithdrawalApplyInfo.shopId = getShopId()
      this.dialogVisible = true
    },
    handleClose() {
      this.resetForm()
    },
    resetForm() {
      this.deleteAccountWithdrawalApplyInfo = {
        applyId: '',
        shopId: ''
      }
    },
    async deleteAccountWithdrawalApply() {
      try {
        const res = await deleteAccountWithdrawalApply(this.deleteAccountWithdrawalApplyInfo)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>